import React, { useState, useEffect, useRef } from "react";
import Lottie from "lottie-react";

const LottieFirework = ({ trigger }) => {
  const [animationData, setAnimationData] = useState(null);
  const [fadeOut, setFadeOut] = useState(true);
  const animationRef = useRef(null);

  useEffect(() => {
    fetch("/assets/fireworkAnimation.json")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch animation");
        }
        return response.json();
      })
      .then((data) => {
        setAnimationData(data);
      })
      .catch((error) => {
        console.error("Error fetching animation:", error);
      });
  }, []);

  useEffect(() => {
    if (trigger && animationData) {
      animationRef?.current?.setSpeed(1);
      animationRef?.current?.goToAndPlay(0);
    }

    return () => {};
  }, [trigger, animationData]);

  const handleAnimationComplete = () => {
    setFadeOut(true);
  };

  const onAnimationComplete = () => {
    setFadeOut(false);
  };

  return (
    <div
      className={`pointer-events-none fixed left-0 top-0 z-50 h-full w-full p-12 ${fadeOut || !trigger ? "hidden" : ""}`}
    >
      <Lottie
        className={`h-full w-full`}
        animationData={animationData}
        lottieRef={animationRef}
        onEnterFrame={onAnimationComplete}
        onComplete={handleAnimationComplete}
        loop={false}
        autoplay={false}
      />
    </div>
  );
};

export default LottieFirework;
